const getOptionGroups = (item = {}) => {
  return [...(item.optionGroups ?? [])]
    .map((group) => ({
      optionGroupNo: Number(group?.optionGroupNo ?? 0),
      optionNos: [...(group?.options ?? [])].map((option) => Number(option?.optionNo ?? 0)).sort((a, b) => a - b)
    }))
    .sort((a, b) => a.optionGroupNo - b.optionGroupNo);
};

export const createCartIdentity = (item = {}) => {
  return JSON.stringify({
    productNo: Number(item?.productNo ?? 0),
    optionGroups: getOptionGroups(item)
  });
};

export const findCartItemIndex = (cart = [], cartItem = {}) => {
  const identity = createCartIdentity(cartItem);
  return cart.findIndex((item) => createCartIdentity(item) === identity);
};

const sortByProductNo = (cart = []) => {
  return [...cart].sort((elem1, elem2) => Number(elem1?.productNo ?? 0) - Number(elem2?.productNo ?? 0));
};

const syncOptionGroupStock = (item = {}, stock = 0) => {
  if (!item.optionGroups || item.optionGroups.length === 0) return item;

  return {
    ...item,
    optionGroups: item.optionGroups.map((group) => ({
      ...group,
      stock
    }))
  };
};

export const mergeCartItems = (cart = []) => {
  const mergedMap = cart.reduce((map, item) => {
    const identity = createCartIdentity(item);
    const prev = map.get(identity);
    const stock = Number(prev?.stock ?? 0) + Number(item?.stock ?? 0);

    map.set(identity, syncOptionGroupStock({ ...item, stock }, stock));
    return map;
  }, new Map());

  return sortByProductNo([...mergedMap.values()].filter((item) => Number(item?.stock ?? 0) > 0));
};

export const addCartItem = (cart = [], cartItem = {}) => {
  if (Number(cartItem?.stock ?? 0) <= 0) {
    return updateCartItem(cart, cartItem);
  }

  return mergeCartItems([...cart, cartItem]);
};

export const updateCartItem = (cart = [], cartItem = {}) => {
  const identity = createCartIdentity(cartItem);
  const stock = Number(cartItem?.stock ?? 0);
  const nextCart = mergeCartItems(cart).filter((item) => createCartIdentity(item) !== identity);

  if (stock <= 0) {
    return nextCart;
  }

  return mergeCartItems([...nextCart, cartItem]);
};
